import React, { useCallback, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { slugify } from '../../../utils/slugify';
import { sessionStorage } from 'dibs-browser-storage';
import { trackFilterClick } from '../../../utils/tracking/searchBrowse/filterTracking';
import { ServerVarsContext } from '../../../global/ServerVarsContext/ServerVarsContext';

// components
import { ExpandingArea } from 'dibs-elements/exports/ExpandingArea';
import { RotatingArrow } from 'dibs-elements/exports/RotatingArrow';

// styles
import styles from './SbSharedRefineMenuFacet.scss';

export const SESSION_STORAGE_KEY = 'facetMenu';

function updateLocalStorage({ isExpanded, storageFacetKey }) {
    const sessionFacetMenu = sessionStorage.getItem(SESSION_STORAGE_KEY) || {};
    sessionStorage.setItem(
        SESSION_STORAGE_KEY,
        Object.assign(sessionFacetMenu, { [storageFacetKey]: isExpanded })
    );
}
function SbSharedRefineMenuFacet({
    title,
    children,
    appliedFiltersComponent,
    storageFacetKey,
    initiallyExpanded,
}) {
    const [isExpanded, setIsExpanded] = useState(initiallyExpanded);
    const { isSbTopNavVariant: shouldIgnoreLocalStorageState } = useContext(ServerVarsContext);
    useEffect(() => {
        const sessionFacetMenu = sessionStorage.getItem(SESSION_STORAGE_KEY) || {};
        const isOpen = sessionFacetMenu[storageFacetKey];
        if (isOpen !== undefined && isExpanded !== isOpen && !shouldIgnoreLocalStorageState) {
            setIsExpanded(isOpen);
        }
    }, [storageFacetKey, isExpanded, shouldIgnoreLocalStorageState]);
    const onLabelClick = useCallback(() => {
        const newExpandedValue = !isExpanded;
        setIsExpanded(newExpandedValue);
        trackFilterClick(title, isExpanded);
        if (!shouldIgnoreLocalStorageState) {
            updateLocalStorage({ storageFacetKey, isExpanded: newExpandedValue });
        }
    }, [isExpanded, storageFacetKey, title, shouldIgnoreLocalStorageState]);

    return (
        <div className={styles.facetContainer}>
            <div
                data-tn={`facet-${slugify(title)}-expanding-area`}
                className={styles.labelWrapper}
                onClick={onLabelClick}
            >
                <div className={styles.titleWrapper}>
                    <div className={styles.title}>{title}</div>
                    {appliedFiltersComponent}
                </div>
                <RotatingArrow direction={isExpanded ? 'up' : 'down'} />
            </div>
            <ExpandingArea expanded={isExpanded} wrapperClass={styles.container}>
                <div className={styles.facetContent} data-tn={`facet-container-${slugify(title)}`}>
                    {children}
                </div>
            </ExpandingArea>
        </div>
    );
}

SbSharedRefineMenuFacet.defaultProps = {
    initiallyExpanded: true,
};

SbSharedRefineMenuFacet.propTypes = {
    initiallyExpanded: PropTypes.bool,
    title: PropTypes.string.isRequired,
    appliedFiltersComponent: PropTypes.node,
    children: PropTypes.node,
    storageFacetKey: PropTypes.string.isRequired,
};

export { SbSharedRefineMenuFacet };
